<template>
    <div>
        <v-card>
            <v-container>
                    <v-timeline>
                    <v-timeline-item v-for='obscom in comentarios' :key="obscom.id">
                                <template v-slot:icon>
                                <v-avatar>
                                    <img :src="obscom.emp.imagen_usuario">
                                </v-avatar>
                                </template>
                        <span slot="opposite">
                          {{obscom.etapaname}}
                          <p>{{momento(obscom.fecha)}}</p>
                        </span>
                            <v-card class="elevation-10">
                            <v-card-title class="headline">{{obscom.alias}}</v-card-title>
                            <v-card-text>
                              <p>{{obscom.emp.nombres}} {{obscom.emp.apellidos}}</p>
                              <span v-html="obscom.comentario"></span>
                            </v-card-text>
                            </v-card>
                    </v-timeline-item>
                    
                    </v-timeline>
            </v-container>
        </v-card>
    </div>
</template>
<script>
import moment from "moment";
moment.locale('es');
export default {
  props: {
    comentarios: {
      type: Array,
      default: null
    },
  },
  methods: {
    momento(fecha){
      return moment(fecha).format('L')
    },
  },
}
</script>